import { cloneDeep } from 'es-toolkit';

import DispatchConstants from '../constants/DispatchConstants';
import { RECS, RECS_TO_MF_SECTION_MAP, REVIEW_PAGE_SECTION_RECS } from '../constants/RecommendationsConstants';

const {
  AMENITIES,
  MEDIA,
  RENT_DETAILS,
  CONTACT,
  PROPERTY_INFORMATION,
  BUILDING_DETAILS,
  FLOOR_PLANS,
  KEY_FEATURES,
  SPECIAL_OFFERS,
  OTHER_PROPERTY_FEATURES,
  POLICIES_AND_TERMS,
  COSTS_AND_FEES,
  SCREENING_CRITERIA,
} = REVIEW_PAGE_SECTION_RECS;

const RecommendationsActions = {
  updateRecommendations(data, isMultifamily = false) {
    return (dispatch) => {
      const recommendationsByReviewPageSectionSF = {
        [RENT_DETAILS]: {},
        [MEDIA]: {},
        [AMENITIES]: {},
        [CONTACT]: {},
        [PROPERTY_INFORMATION]: {},
        [COSTS_AND_FEES]: {},
        [SCREENING_CRITERIA]: {},
      };

      const recommendationsByReviewPageSectionMF = {
        [BUILDING_DETAILS]: {},
        [CONTACT]: {},
        [MEDIA]: {},
        [FLOOR_PLANS]: {},
        [SPECIAL_OFFERS]: {},
        [KEY_FEATURES]: {},
        [OTHER_PROPERTY_FEATURES]: {},
        [POLICIES_AND_TERMS]: {},
        [COSTS_AND_FEES]: {},
        [SCREENING_CRITERIA]: {},
      };

      const recommendationsByType = {};

      data.recommendations.forEach((rec) => {
        const copyRec = { ...rec };
        recommendationsByType[rec.type] = copyRec;

        if (!rec.isComplete) {
          if (isMultifamily) {
            const section = RECS_TO_MF_SECTION_MAP[rec.type];
            if (section) {
              recommendationsByReviewPageSectionMF[section][rec.type] = copyRec;
            }
          } else {
            if (rec.type === RECS.PHOTOS || rec.type === RECS.VIRTUAL_TOUR) {
              recommendationsByReviewPageSectionSF[MEDIA][rec.type] = copyRec;
            } else if (
              rec.type === RECS.HIDE_STREET_ADDRESS ||
              rec.type === RECS.SQUARE_FOOTAGE ||
              rec.type === RECS.DESCRIPTION
            ) {
              recommendationsByReviewPageSectionSF[PROPERTY_INFORMATION][rec.type] = copyRec;
            } else if (rec.type === RECS.AMENITIES || rec.type === RECS.LAUNDRY || rec.type === RECS.PARKING) {
              recommendationsByReviewPageSectionSF[AMENITIES][rec.type] = copyRec;
            } else if (rec.type === RECS.SECURITY_DEPOSIT || rec.type === RECS.PRICE) {
              recommendationsByReviewPageSectionSF[RENT_DETAILS][rec.type] = copyRec;
            } else if (rec.type === RECS.PETS_NOT_ALLOWED) {
              recommendationsByReviewPageSectionSF[SCREENING_CRITERIA][rec.type] = copyRec;
            } else if (rec.type === RECS.ADMINISTRATIVE_FEE) {
              recommendationsByReviewPageSectionSF[COSTS_AND_FEES][rec.type] = copyRec;
            } else if (
              rec.type === RECS.LEASE_LENGTH ||
              rec.type === RECS.LEASE_TERMS ||
              rec.type === RECS.SCHEDULE ||
              rec.type === RECS.APPLICATIONS ||
              rec.type === RECS.HIDE_PHONE ||
              rec.type === RECS.CONTACT ||
              rec.type === RECS.DATE_AVAILABLE
            ) {
              recommendationsByReviewPageSectionSF[CONTACT][rec.type] = copyRec;
            }
          }
        }
      });

      dispatch({
        type: DispatchConstants.UPDATE_RECOMMENDATIONS,
        payload: {
          isEnabled: data.isEnabled,
          recommendations: cloneDeep(data.recommendations),
          recommendationsByType,
          completeness: data.completeness,
          // MF
          [BUILDING_DETAILS]: recommendationsByReviewPageSectionMF[BUILDING_DETAILS],
          [FLOOR_PLANS]: recommendationsByReviewPageSectionMF[FLOOR_PLANS],
          [SPECIAL_OFFERS]: recommendationsByReviewPageSectionMF[SPECIAL_OFFERS],
          [KEY_FEATURES]: recommendationsByReviewPageSectionMF[KEY_FEATURES],
          [OTHER_PROPERTY_FEATURES]: recommendationsByReviewPageSectionMF[OTHER_PROPERTY_FEATURES],
          [POLICIES_AND_TERMS]: recommendationsByReviewPageSectionMF[POLICIES_AND_TERMS],
          // SF
          [PROPERTY_INFORMATION]: recommendationsByReviewPageSectionSF[PROPERTY_INFORMATION],
          [AMENITIES]: recommendationsByReviewPageSectionSF[AMENITIES],
          [RENT_DETAILS]: recommendationsByReviewPageSectionSF[RENT_DETAILS],
          // SF and MF
          [MEDIA]: isMultifamily
            ? recommendationsByReviewPageSectionMF[MEDIA]
            : recommendationsByReviewPageSectionSF[MEDIA],
          [CONTACT]: isMultifamily
            ? recommendationsByReviewPageSectionMF[CONTACT]
            : recommendationsByReviewPageSectionSF[CONTACT],
          [COSTS_AND_FEES]: isMultifamily
            ? recommendationsByReviewPageSectionMF[COSTS_AND_FEES]
            : recommendationsByReviewPageSectionSF[COSTS_AND_FEES],
          [SCREENING_CRITERIA]: isMultifamily
            ? recommendationsByReviewPageSectionMF[SCREENING_CRITERIA]
            : recommendationsByReviewPageSectionSF[SCREENING_CRITERIA],
        },
      });
    };
  },
};

export default RecommendationsActions;
